import { render } from "./ResumeComponent.vue?vue&type=template&id=35f29c0c&scoped=true"
import script from "./ResumeComponent.vue?vue&type=script&lang=js"
export * from "./ResumeComponent.vue?vue&type=script&lang=js"

import "./ResumeComponent.vue?vue&type=style&index=0&id=35f29c0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f29c0c"]])

export default __exports__